import React, { FC, memo } from 'react'
import { useFormContext } from '../forms/form'
import FieldError, { useFieldValidity } from './fieldError'

interface EmailInputProps {
    label: string
    value: string
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
    placeholder?: string
    required?: boolean
    autoComplete?: string
    maxLength?: number
    helperText?: string
}

const EmailInput: FC<EmailInputProps> = ({ label, value, onChange, placeholder = '', required = false, autoComplete = ``, maxLength, helperText }) => {
    const { disableInputs, isLoading } = useFormContext()
    const { errorMessage, fieldClassName, onBlur, onChange: onValidityChange, onInvalid } = useFieldValidity()

    return (
        <div className="input-holder">
            <label>{label}{required ? '*' : ''}</label>
            <input
                type="email"
                value={value}
                placeholder={placeholder}
                onChange={(e) => {
                    onValidityChange(e)
                    onChange(e)
                }}
                onBlur={onBlur}
                onInvalid={onInvalid}
                autoComplete={autoComplete}
                required={required}
                disabled={disableInputs}
                className={`${fieldClassName} ${isLoading ? 'animate-pulse' : ''}`}
                maxLength={maxLength}
            />
            <FieldError message={errorMessage} />
            {helperText && (
                <div className="text-xs text-gray-500 mt-1">
                    {helperText}
                </div>
            )}
        </div>
    )
}

export default memo(EmailInput)

